import { api } from '@/lib/axios'

export interface ComoAjudarData {
  data: {
    name: string
    email: string
    telefone?: string
    newsletter?: string
    whatsapp?: string
  }
}

export interface ComoAjudarResponse {
  success: boolean
  protocolCode: string
}

export async function comoajudar({
  data,
}: ComoAjudarData): Promise<ComoAjudarResponse> {
  const response = await api.post<ComoAjudarResponse>('/leads', { data })
  return response.data
}
